const Expertise = (props) => {
  return (
    <div className="flex w-full ">
      <div className="bg-[#F7F9FF] language-height relative flex  pt-10 2xl:pt-24 w-full ">
        <span className="hidden md:block w-2/5 text-left pl-7 lg:pl-10 2xl:pl-28 font-headline font-extrabold text-5xl lg:text-6xl xl:text-7xl">
          Expertise in design and verification
        </span>
      </div>
      <div className="bg-transparent flex mx-7 lg:mx-10 xl:mx-28 overflow-y-scroll scroll-height body-scroll absolute z-10 language-height">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="flex">
            <div></div>
            <div className="block md:hidden font-headline font-extrabold text-5xl pt-10">
              Expertise in diverse DV{" "}
            </div>
          </div>
          <div className="flex">
            <ul className="flex flex-col pt-10 2xl:pt-24">
              <li className="flex group">
                <span className="flex border-b border-gray-200 group-hover:border-blue-500 pb-6 lg:pb-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-headline font-extrabold text-xl md:text-5xl mr-8">
                    01
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    SV for hardware design and linear verification
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-headline font-extrabold text-xl md:text-5xl mr-8">
                    02
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    UVM test architecture for VIP and complex hardware
                    verification
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    03
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    SystemC verification for complete system model simulation
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    04
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    Integration and automation with scripting languages such as
                    C++, Python, and bash makefile scripts
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    05
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    RISC ISA verification on CVA6 processors using SPIKE model
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    06
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    RISC-V assembly and machine code simulation and validation
                    for functionality
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    07
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    SV, Verilog, and VHDL support for FPGA programming
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-y border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    08
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    C, C++, and python support for microcontrollers such as
                    ESP32 with freeRTOS
                  </p>
                </span>
              </li>
              <li className="flex group">
                <span className="flex border-t border-gray-200 group-hover:border-blue-500 py-6 lg:py-16">
                  <span className="group-hover:text-blue-500 text-neutral-200 font-extrabold font-headline text-xl md:text-5xl mr-8">
                    09
                  </span>
                  <p className="font-headline text-neutral-600 group-hover:text-blue-500 text-normal text-2xl md:text-4xl">
                    Tailored and AI-driven backend testing and verification for
                    layout, PnR, and physical testing
                  </p>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
